import { createContext, useContext } from 'react';
export const BrandingContext = /*#__PURE__*/ createContext(undefined);
/**
 * Hook to access branding overrides from a parent BrandingProvider.
 * Returns undefined if not wrapped in a BrandingProvider.
 */ export const useBrandingOverrides = ()=>{
    return useContext(BrandingContext);
};

//# sourceMappingURL=brandingContext.js.map